<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.name"
                        placeholder="รายการ"/>
                    &nbsp
                    <date-picker
                        v-model="search.start_date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                    </date-picker>
                    &nbsp&nbsp
                    <select class="form-control" v-model="search.status">
                        <option disabled hidden value="">สถานะ</option>
                        <option value="1">Inactive</option>
                        <option value="2">Active</option>
                    </select>
                    &nbsp&nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchPromotion">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp&nbsp
                    <router-link to="/promotions-form">
                        <button class="btn btn-warning my-2 my-sm-0">
                            <icon name="plus"></icon>
                            เพิ่มโปรโมชั่น
                        </button>
                    </router-link>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อโปรโมชั่น</th>
                    <th>คูปอง</th>
                    <th>Active</th>
                    <th>วันเริ่มต้น</th>
                    <th>วันสิ้นสุด</th>
                    <th>สถานะ</th>
                    <th>สร้างโปรโมชั่น</th>
                    <th>แก้/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in promotionList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        <template v-if="data.name">{{ data.name }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.coupon">{{ data.coupon }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.description">{{ data.description }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.start_date">
                            {{ data.start_date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.end_date">
                            {{ data.end_date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.status_name">{{ data.status_name }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <button type="button" class="btn btn-info"
                                @click="showDuplicatePromotion(data)">
                            <icon name="plus"></icon>
                            โปรโมชั่นรายการเดียวกัน
                        </button>
                    </td>
                    <td>
                        <a @click="goToPromotionForm(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="promotionList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPromotion">
            </vue-pagination>
        </div>
        <!--delete modal-->
        <b-modal hide-header hide-footer ref="delete_data">
            <div style="text-align: center;">
                <h4>คุณต้องการลบโปรโมชั่นนี้ใช่ไหม?</h4>
                <br/>
                <button @click="deletePromotion"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--duplicate promotion modal-->
        <b-modal hide-header hide-footer
                 ref="duplicate_promotion">
            <div>
                <duplicate-promotion-modal @submit="duplicatePromotions"/>
            </div>
        </b-modal>
        <!--<pre class="alert-primary">{{promotionList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import VuePagination from "../../Pagination";
import DuplicatePromotionModal from "./DuplicatePromotionModal";

export default {
    components: {
        DuplicatePromotionModal,
        VuePagination,
        DatePicker,
    },
    name: "promotion-list",
    created() {
        this.$store.dispatch("Promotion/setPromotion");
    },
    data() {
        return {
            promotions_product: [],
            event_submit: false,
            delete_id: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            promotionList: state => {
                return state.Promotion.promotionList;
            },
            search: state => {
                return state.Promotion.search;
            },
            dataPaginate: state => {
                return state.Promotion.dataPaginate;
            },
        })
    },
    methods: {
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        showPromotion(id) {
            this.$store.dispatch("Promotion/showPromotion", id);
        },
        goToPromotionForm(id) {
            this.showPromotion(id);
            this.$router.push({
                name: "promotions-form",
                params: {id}
            });
        },
        searchProduct() {
            this.$store.dispatch("Promotion/search")
        },
        searchPromotion() {
            this.event_submit = true;
            let start_date = "";
            let end_date = "";

            //change date format
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            let data = {
                name: this.search.name,
                start_date: start_date,
                end_date: end_date,
                status: this.search.status,
            };
            //console.log(this.search);
            this.$store.dispatch("Promotion/searchPromotion", data)
        },
        getPromotion() {
            const page = this.dataPaginate.current_page;
            if (this.search.start_date) {
                this.search.start_date = moment(this.search.start_date).format("YYYY-MM-DD");
            } else {
                this.search.start_date = "";
            }
            if (this.search.end_date) {
                this.search.end_date = moment(this.search.end_date).format("YYYY-MM-DD");
            } else {
                this.search.end_date = "";
            }

            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('Promotion/searchPromotion', {
                    page: page,
                    name: this.search.name,
                    start_date: this.search.start_date,
                    end_date: this.search.end_date,
                    status: this.search.status,
                })
            }
            //paginate get data
            else {
                this.$store.dispatch('Promotion/setPromotion', page)
            }
        },
        deletePromotion() {
            this.$store.dispatch('Promotion/deletePromotion', this.delete_id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("Promotion/setPromotion");
            })
        },
        showDuplicatePromotion(promotion) {
            this.promotions_product = [];
            promotion.promotion_products.forEach(product => {
                this.promotions_product.push(product.product_id);
            });
            this.$refs.duplicate_promotion.show();
        },
        duplicatePromotions(value) {
            if (value) {
                let data = {
                    name: value.name,
                    description: value.description,
                    status_id: 1,
                    start_date: "",
                    end_date: "",
                    condition: value.condition,
                    quantity: value.quantity,
                    unit_type: value.unit_type,
                    discount: value.discount,
                    discount_status_id: value.discount_status_id,
                    promotion_products: this.promotions_product,
                };
                this.$store.dispatch("Promotion/savePromotion", {
                    id: "",
                    data: data,
                }).then(() => {
                    this.$store.dispatch("Promotion/setPromotion");
                })
            }
            this.$refs.duplicate_promotion.hide();
        }

    }
}
</script>

<style scoped>

</style>
